export const renewalEndpoints = {
  getStats: { method: 'get', path: '/get-stats' },
  uploadRenewals: { method: 'post', path: '/upload' },
  sendRenewal: { method: 'post', path: '/{id}/send' },
  createRenewal: { method: 'post', path: '/' },
  deleteRenewal: { method: 'post', path: '/{id}/delete' },
  listRenewalsPaginated: { method: 'post', path: '/paginated' },
  updateRenewal: { method: 'post', path: '/{id}/update' },
  updateTriggeredRenewal: { method: 'post', path: '/{id}/update-triggered-renewal' },
  getRenewal: { method: 'get', path: '/{id}' },
} as const
